const ClaimTypeFilter = ({
  claimLabel,
  recordCount,
  isActive,
  claimClickHanler,
  isComingFromDocuments,
}) => {
  return (
    <>
      <span
        className={`each-claim-type ${isActive}`}
        onClick={() => {
          claimClickHanler(claimLabel);
        }}
        title={claimLabel}
      >
        {isComingFromDocuments && isComingFromDocuments
          ? claimLabel.length > 26
            ? claimLabel.substring(0, 26) + '...'
            : claimLabel
          : claimLabel.length > 12
          ? claimLabel.substring(0, 12) + '...'
          : claimLabel}
        &nbsp;{recordCount && `(${recordCount})`}
      </span>
    </>
  );
};
export default ClaimTypeFilter;
